import React from 'react';
import { motion } from 'framer-motion';
export function ObjectionHandler() {
  const quotes = ['Si te da vergüenza pedir compañía, esto es para ti.', 'No estás «muy sensible». Estás sola a esta hora.', 'Tu casa puede sentirse hogar otra vez.', 'Sin apps raras. Sin terapia cara. Sin forzarte.'];
  return <section className="py-24 md:py-32 px-4 bg-[#1a1714]" data-id="element-51">
      <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-52">
        {quotes.map((quote, index) => <motion.div key={index} initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: index * 0.2
      }} className="relative pl-8 py-2" data-id="element-53">
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#d4a574]/30 rounded-full" data-id="element-54" />
            <p className="text-xl md:text-2xl font-serif italic text-[#f5efe6]/80 leading-relaxed" data-id="element-55">
              {quote}
            </p>
          </motion.div>)}
      </div>
    </section>;
}